import AppContext from "AppContext";
import { alert } from "components/Alert";
import CustomDropzone from "components/CustomDropzone";
import GeneralForm from "components/GeneralForm";
import { validate } from "components/validateGeneralForm";
import { useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Button, Col, FormGroup, Input, Label, Modal, ModalBody, ModalHeader, Row } from "reactstrap";
import anexoCruzamentoService from "services/AnexoCruzamentoService";
import arquivoService from "services/ArquivoService";
import comboService from "services/ComboService";
import { erroInesperado } from "services/Utils";

export default function ModalAnexar({ config, onChange, onClose }) {
  const [data, setData] = useState({
    idCruzamento: config?.idCruzamento
  })
  const [arquivo, setArquivo] = useState(null)
  const [tiposAnexo, setTiposAnexo] = useState([])
  const { state } = useContext(AppContext)

  useEffect(() => {
    setData({ idCruzamento: config?.idCruzamento })
    setArquivo(null)
  }, [config])

  useEffect(() => {
    comboService.tipoAnexoCruzamento().then(res => {
      if (res.success) {
        setTiposAnexo(res.data)
      }
    })
  }, [])

  const formConfig = [
    [
      {
        name: "idTipoAnexo", label: 'Tipo de Anexo', type: "combo", required: true, colspan: 12,
        options: tiposAnexo, optionValue: 'id', optionLabel: 'descricao', showDefault: true,
      },
      {
        name: "arquivo",
        type: "view",
        required: false,
        colspan: 6,
        component: () => {
          if (arquivo || data.logo) {
            const nomeArquivo = arquivo ? arquivo.name : data.logo.nomeArquivo
            const funcaoExcluir = arquivo ? () => handleChangeArquivo(null) : () => handleChange('arquivo', null)
            return (
              <Row>
                <Col xs={12}>
                  <FormGroup>
                    <Label>Logo</Label>
                    <Input type="text" value={nomeArquivo} disabled={true} />
                  </FormGroup>
                </Col>
                <Col xs={4} className="d-flex align-items-end">
                  <FormGroup>
                    <Button color="danger" outline onClick={funcaoExcluir}>
                      Excluir
                    </Button>
                  </FormGroup>
                </Col>
              </Row>
            )
          }
          return (
            <div className="mb-3">
              <div>Arquivo</div>
              <CustomDropzone
                onChange={value => handleChangeArquivo(value)}
                onRemove={() => handleChangeArquivo(null)}
                edit={true}
              />
            </div>
          )
        }
      }
    ]
  ]

  const handleChangeArquivo = (value) => {
    if (!value) {
      setData({ ...data, arquivo: null })
    }
    setArquivo(value)
  }


  const handleChange = (name, value) => {
    setData({ ...data, [name]: value })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    const errors = validate(formConfig, data)
    if (errors.length > 0) {
      setData({ ...data, errors })
      return
    }

    if (!arquivo) {
      alert({
        header: 'Atenção',
        text: 'Selecione um arquivo',
        icon: 'bi-exclamation-triangle'
      })
      return
    }

    try {
      const res = await arquivoService.upload(arquivo)
      if (res.success) {
        data.arquivo = { id: res.data }
      } else {
        toast('Erro ao enviar arquivo')
        return
      }

      await anexoCruzamentoService.create(data)
      toast('Registro salvo com sucesso!')
      onChange && onChange()
      onClose && onClose()
    } catch (ex) {
      erroInesperado()
    }
  }

  return (
    <Modal isOpen={!!config} toggle={onClose} size="lg">
      <ModalHeader toggle={onClose}>Anexar Documento</ModalHeader>
      <ModalBody>
        <form onSubmit={handleSubmit}>
          <GeneralForm
            config={formConfig}
            data={data}
            onChange={handleChange}
          />
          <Button type="submit" color="primary">Salvar</Button>
          <Button type="button" color="primary" outline onClick={onClose}>Cancelar</Button>
        </form>
      </ModalBody>
    </Modal>
  )
}
